import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useStyles } from '~/modules/projects/project/BillPlan/BillPlanPreRequisites/hooks';
import AddMilestoneTaskLink from './AddMilestoneTaskLink';

export const BillPlanSuccess = ({
  title,
  projectDetails,
  setMilestoneTaskCreated,
  setTaskAddedCount,
  milestoneTaskCreated
}) => {
  const classes = useStyles();

  return (
    <Grid container spacing={0}>
      <div className={classes.root}>
        <Alert
          severity="success"
          className={classes.alert}
          data-qe-id="SuccessMessage"
        >
          <strong>{title}</strong>
          {milestoneTaskCreated ? (
            <AddMilestoneTaskLink
              projectDetails={projectDetails}
              setMilestoneTaskCreated={setMilestoneTaskCreated}
              setTaskAddedCount={setTaskAddedCount}
            />
          ) : null}
        </Alert>
      </div>
    </Grid>
  );
};

BillPlanSuccess.propTypes = {
  title: PropTypes.string,
  projectDetails: PropTypes.object,
  setMilestoneTaskCreated: PropTypes.func,
  setTaskAddedCount: PropTypes.func,
  milestoneTaskCreated: PropTypes.bool
};

export default BillPlanSuccess;
